import { UI_EXPERIENCE_OVERRIDE } from 'common/api/storageConsts'
import { getRuntimeEnv, isTrueValue } from 'common/helpers/uiBrandEnvironment'

import { UiExperience } from './types'

const OVERRIDE_QUERY_PARAM = 'experience'

export const isUiExperience = (value: unknown): value is UiExperience =>
  value === 'legacy' || value === 'next'

/** Enables `?experience=` and the views still marked as preview (dev/QA only). */
export const isExperiencePreviewEnabled = () =>
  isTrueValue(getRuntimeEnv('REACT_APP_UI_EXPERIENCE_OVERRIDE'))

/** Must run before the router drops the query string, so the override survives SPA navigation. */
export const captureExperienceOverride = () => {
  if (!isExperiencePreviewEnabled()) return
  const value = new URLSearchParams(window.location.search).get(OVERRIDE_QUERY_PARAM)
  if (isUiExperience(value)) {
    storeExperienceOverride(value)
  }
}

export const storeExperienceOverride = (value: UiExperience) =>
  sessionStorage.setItem(UI_EXPERIENCE_OVERRIDE, value)

export const getExperienceOverride = (): UiExperience | undefined => {
  if (!isExperiencePreviewEnabled()) return undefined
  const value = sessionStorage.getItem(UI_EXPERIENCE_OVERRIDE)
  return isUiExperience(value) ? value : undefined
}

export const clearExperienceOverride = () => sessionStorage.removeItem(UI_EXPERIENCE_OVERRIDE)
